import CreationTool from 'creation/src/creation-tools/types/creation-tool'

/**
 * Replacement for the legacy CreationTool.peekerUrl method, removed from the
 * shared package in Task 3 (asset paths aren't shared-logic). Paths mirror
 * app/static/js/site/creation-tools/types/creation-tool.ts verbatim.
 */
export const toolPeekerUrl = (tool: CreationTool): string => {
    switch (tool) {
        case CreationTool.GifMaker:
            return '/static/img/creation_tools/gif-maker-peeker.gif'
        case CreationTool.Upload:
            return '/static/img/creation_tools/upload-peeker.gif'
        case CreationTool.SuperCut:
            return '/static/img/creation_tools/supercut-peeker.gif'
        default:
            return ''
    }
}

/**
 * Legacy counterpart: `backgroundVideoUrls` in the same legacy file. Drives the
 * welcome screen's full-viewport background video (see ../background.tsx).
 *
 * These stay under `/static/` rather than moving into `app/nextjs/public/`
 * because nginx routes `/static/` straight to the S3 bucket that Django's
 * `collectstatic` fills (bin/confd/web-nginx/templates/nginx.conf.tmpl) — it
 * never reaches the Next server. A file in `app/nextjs/public/` is served at
 * the site root, which nginx does not route to Next at all, so it would work
 * locally and 404 in production. Same reasoning as toolPeekerUrl above.
 */
export const toolBackgroundVideoUrl = (tool: CreationTool): string => {
    switch (tool) {
        case CreationTool.GifMaker:
            return '/static/img/videos/9rv8tcpftaJcBDLamd.mp4'
        case CreationTool.Upload:
            return '/static/img/videos/forest-still.mp4'
        case CreationTool.SuperCut:
            return '/static/img/videos/gachapon.mp4'
        default:
            return ''
    }
}
